const numberToString = (number, decimalPlaces) => {
  return `${number.toFixed(decimalPlaces)}`;
};

const addCommasToNumberString = (numberString) => {
  // todo handle chinese formatting based on powers of 10,000 (see https://www.wikiwand.com/en/Decimal_mark for more information)
  return numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const isNotANumber = (number) => {
  return Number.isNaN(number) || typeof number !== 'number';
};

export class NumberFormattingService {
  static roundToPlace(number, placesToRound, removeTrailingZeroes = false) {
    if (isNotANumber(number) || placesToRound === undefined || placesToRound < 0) {
      return undefined;
    }
    if (placesToRound === 0) {
      return `${Math.round(number)}`;
    }
    const floorPlacesToRound = Math.floor(placesToRound);
    const multipleOfTen = 10 ** floorPlacesToRound;
    let fixedNumber = Number.parseFloat((Math.round(number * multipleOfTen) / multipleOfTen).toFixed(floorPlacesToRound));
    if (removeTrailingZeroes) {
      fixedNumber = fixedNumber.toString();
    }
    return fixedNumber;
  }

  static addCommasToNumber(number, decimalPlaces = 0, removeTrailingZeroes = false) {
    if (isNotANumber(number)) {
      return '';
    }
    const roundedNumber = this.roundToPlace(number, decimalPlaces, removeTrailingZeroes);
    const numberString = typeof roundedNumber === 'string' ? roundedNumber : numberToString(roundedNumber, decimalPlaces);
    const stringParts = numberString.split('.');
    return addCommasToNumberString(stringParts[0]) + (stringParts.length > 1 ? `.${stringParts[1]}` : '');
  }
}
